<template>
  <div class="sticky-left mb-2">
    <div v-if="is_bread" class="breadcrumb_container my-2">
      <ol class="breadcrumb m-0 pb-2">
        <li class="breadcrumb-item">
          <router-link to="/">Dashboard</router-link>
        </li>
        <li v-for="(item, index) in breadcrumb" :key="item.name" class="breadcrumb-item" :class="{ active: index + 1 == breadcrumb.length || item.path == '' }">
          <span v-if="index + 1 == breadcrumb.length || item.path == ''" v-html="item.name"></span>
          <router-link v-else :to="item.path">{{ item.name }}</router-link>
        </li>
      </ol>
    </div>
    <slot name="sticky"></slot>
  </div>
  <slot name="content">
    <div class="coming_soon">
      <h3>Coming Soon</h3>
    </div>
  </slot>
  <div v-if="scrollTopBtn" @click.prevent="scrollToTop" class="scroll_up" :class="{ mobile: $device?.mobile }">
    <i class="fi fi-angle-up"></i>
  </div>
  <div v-if="is_loading" class="loading">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: "Container",
  props: {
    is_bread: { type: Boolean, default: true },
    scrollTopBtn: { type: Boolean, default: true },
    is_loading: { type: Boolean, default: false }
  },
  computed: {
    breadcrumb() {
      if (typeof this?.$parent?.$options?.breadcrumb == "function") {
        return this?.$parent?.$options?.breadcrumb.call(this.$parent);
      }
      return this?.$parent?.$options?.breadcrumb || [];
    }
  },
  created() {
    if (this.scrollTopBtn && document.querySelector(".content_container")) {
      document.querySelector(".content_container").addEventListener("scroll", (evt) => {
        if (document.querySelector(".scroll_up")) {
          if (evt.target.scrollTop > 100) {
            document.querySelector(".scroll_up").classList.add("active");
          } else {
            document.querySelector(".scroll_up").classList.remove("active");
          }
        }
      });
    }
  },
  methods: {
    scrollToTop() {
      document.querySelector(".content_container").scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped lang="scss">
.breadcrumb_container {
  ol {
    &.breadcrumb {
      font-size: var(--fnt-10);
      font-weight: 600;
      li {
        color: var(--body-text-color) !important;
        &::before {
          color: var(--dp-c-breadcrumb-active-color);
        }
        a {
          color: var(--body-text-color) !important;
          text-decoration: none;
        }
        &.active {
          color: var(--dp-c-breadcrumb-active-color) !important;
        }
      }
    }
  }
}

.coming_soon {
  display: flex;
  height: 50vh;
  justify-content: center;
  align-items: center;
}

.scroll_up {
  position: fixed;
  bottom: 25px;
  right: 70px;
  z-index: 1;
  color: var(--white);
  width: 35px;
  height: 35px;
  border: 2px solid var(--teal);
  background-color: var(--teal);
  display: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  &.mobile {
    bottom: 70px;
    right: 25px;
  }
  &.active {
    display: flex;
  }
}
</style>
